/* eslint-disable react/no-unescaped-entities */
import {
  Activity,
  Heart,
  Wheat,
  Smartphone,
  BarChart3,
  ArrowUpRight,
} from "lucide-react";
import { useT } from "@/lib/i18n";

const itemsMeta = [
  {
    key: "sante",
    icon: Activity,
    className: "md:col-span-8 md:row-span-2 bg-[#1C3A27] text-white",
    isPrimary: true,
    testId: "feature-sante",
  },
  {
    key: "reproduction",
    icon: Heart,
    className: "md:col-span-4 bg-white",
    testId: "feature-reproduction",
  },
  {
    key: "alimentation",
    icon: Wheat,
    className: "md:col-span-4 md:row-span-2 bg-[#F0F0EB]",
    testId: "feature-alimentation",
  },
  {
    key: "mobile",
    icon: Smartphone,
    className: "md:col-span-4 bg-white",
    testId: "feature-mobile",
  },
  {
    key: "analyses",
    icon: BarChart3,
    className: "md:col-span-4 bg-white",
    testId: "feature-analyses",
  },
];

export default function Features() {
  const t = useT();
  return (
    <section
      id="features"
      data-testid="features-section"
      className="py-24 md:py-32 bg-[#FAFAF7] relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <div className="text-sm font-bold uppercase tracking-[0.2em] text-[#E05A3D]">
            {t.features.overline}
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl font-black tracking-tight text-[#1C3A27]">
            {t.features.headline_a}{" "}
            <span className="italic font-black text-[#5C6B5C]">
              {t.features.headline_b}
            </span>
          </h2>
          <p className="mt-6 text-lg text-[#5C6B5C] leading-relaxed">
            {t.features.description}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 auto-rows-[200px] gap-5">
          {itemsMeta.map((it) => {
            const Icon = it.icon;
            const c = t.features.items[it.key];
            return (
              <div
                key={it.key}
                data-testid={it.testId}
                className={`group rounded-[1.75rem] border border-[#E2E4DF] p-7 md:p-9 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${it.className}`}
              >
                <div
                  className={`w-12 h-12 rounded-2xl grid place-items-center ${
                    it.isPrimary
                      ? "bg-[#E05A3D] text-white"
                      : "bg-[#1C3A27]/5 text-[#1C3A27]"
                  }`}
                >
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <div>
                  <div className="flex items-center justify-between">
                    <h3
                      className={`font-display font-bold text-2xl md:text-3xl ${
                        it.isPrimary ? "text-white" : "text-[#1C3A27]"
                      }`}
                    >
                      {c.title}
                    </h3>
                    <ArrowUpRight
                      size={20}
                      className={`opacity-0 group-hover:opacity-100 transition ${
                        it.isPrimary ? "text-white" : "text-[#1C3A27]"
                      }`}
                    />
                  </div>
                  <p
                    className={`mt-3 text-base leading-relaxed max-w-md ${
                      it.isPrimary ? "text-white/80" : "text-[#5C6B5C]"
                    }`}
                  >
                    {c.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
